module.exports = __webpack_public_path__ + "media/Anna.cbba510c.mp4";